export const CATEGORIES = {
  DREAM_CHASER: 'Dream Chaser',
  WEALTH_ARCHITECT: 'Wealth Architect',
  SAFETY_SEEKER: 'Safety Seeker',
  GENEROUS_ALTRUIST: 'Generous Altruist',
  FREEDOM_FINDER: 'Freedom Finder'
} as const;